"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnGap = exports.Columns = void 0;
var Columns;
(function (Columns) {
    Columns["One"] = "u-columns-1";
    Columns["Two"] = "u-columns-2";
    Columns["Three"] = "u-columns-3";
    Columns["Four"] = "u-columns-4";
})(Columns = exports.Columns || (exports.Columns = {}));
var ColumnGap;
(function (ColumnGap) {
    ColumnGap["Normal"] = "u-column-gap";
    ColumnGap["Zero"] = "u-column-gap-0";
    ColumnGap["Two"] = "u-column-gap-2";
})(ColumnGap = exports.ColumnGap || (exports.ColumnGap = {}));
//# sourceMappingURL=Columns.js.map